// Lib
import detectIndent from 'detect-indent';

/**
 * Return indentation of a line.
 */
const getIndentForLine = (line) => detectIndent(line).indent || '';

export default getIndentForLine;
